import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { g } from "@/lib/api";

const Ctx = createContext(null);

export const PlanProvider = ({ children }) => {
  const [plan, setPlan] = useState(null);
  const [upgrade, setUpgrade] = useState(null);

  const refreshPlan = useCallback(async () => setPlan(await g("/plan")), []);
  useEffect(() => {
    refreshPlan();
  }, [refreshPlan]);

  const has = (f) => !!plan?.features?.includes(f);

  const askUpgrade = (feature, message, needed = "standard") =>
    setUpgrade({ feature, message, needed });

  // Trasforma l'errore 402 "upgrade:<piano>:<messaggio>" in dialog di upgrade.
  const handleError = (e) => {
    const d = e?.response?.data?.detail;
    if (e?.response?.status === 402 && typeof d === "string" && d.startsWith("upgrade:")) {
      const [, needed, ...rest] = d.split(":");
      setUpgrade({ needed, message: rest.join(":") });
      return true;
    }
    return false;
  };

  return (
    <Ctx.Provider value={{ plan, refreshPlan, has, upgrade, askUpgrade, closeUpgrade: () => setUpgrade(null), handleError }}>
      {children}
    </Ctx.Provider>
  );
};

export const usePlan = () => useContext(Ctx);
